import { Formatter } from "./Formatter";

export class CpfFormatter implements Formatter {

  constructor(private readonly cpf: string) { }

  public readonly format = () => this.cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

}